import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { TimeZonePickerDropdownListModule } from '../time-zone-picker-dropdown-list/time-zone-picker-dropdown-list.module';
import { DropdownModule } from './../../../common/dropdown/dropdown.module';
import { TimeZonePickerDropdownComponent } from './time-zone-picker-dropdown.component';

@NgModule({
  declarations: [TimeZonePickerDropdownComponent],
  exports: [TimeZonePickerDropdownComponent],
  imports: [DropdownModule, I18nModule, TimeZonePickerDropdownListModule],
})
export class TimeZonePickerDropdownModule {}
export { TimeZonePickerDropdownComponent } from './time-zone-picker-dropdown.component';
